(function ($) {
    if (!(navigator.vendor.match(/apple/i))) {
        window.onload = function () {
            lax.init()

            // Add a driver that we use to control our animations
            lax.addDriver('scrollY', function () {
                return window.scrollY
            })

            // Add animation bindings to elements
            lax.addElements('.js-translate-on-scroll', {
                scrollY: {
                    translateY: [
                        ["elOutY", "elCenterY", "elInY"],
                        [400, -50, -200]
                    ]
                },
            })
        }
    }
})(jQuery);